import React, { Component } from 'react';

export default class ErrorPage extends Component {
  render() {
    return(
      <div className="content-max-width cms">
        <h1>Oh no!</h1>
        <p>Our data has gone missing, but don't worry&mdash;we're on the case!</p>
        <p>(Sometimes reloading works; <a href="/">click here</a> to give it a shot.)</p>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ErrorPage.jsx